import Vue from 'vue'
import VueRouter from 'vue-router'
import {TOKEN_NAME, USER_DETAILS} from '@/services/ConstantService'

// Route Settings
import {RouteSettings} from '@/router/RouteSettings';
import {RoutePsc} from '@/router/RoutePsc';
import {RouteInternalAudit} from "@/router/RouteInternalAudit";
import {RouteRightship} from "@/router/RouteRightship";
import VesselDocuments from "@/components/vessel/documents/VesselDocuments.vue";
import VesselVisitation from "@/components/vessel/documents/partials/VesselVisitation.vue";
import VesselFiles from "@/components/vessel/documents/partials/VesselFiles.vue";
const VesselHistory  = () => import("@/components/vessel/VesselHistory");
const AccidentIncidentHistory  = () => import("@/components/vessel/history/AccidentIncidentHistory");
const PscInspectionHistory  = () => import("@/components/vessel/history/PscInspectionHistory");
const VesselInternalAuditHistory = () => import('@/components/modules/ia/vessel/VesselAuditRecordList');
const CompanyInstruction  = () => import("@/views/CompanyInstruction.vue");
const AirCompanyInstructionList  = () => import("@/components/modules/company-instruction/AirCompanyInstructionList.vue");
const MasterAirCompanyInstruction = () => import("@/components/modules/company-instruction/master/MasterAirCompanyInstruction.vue")
const StaffAirCompanyInstruction = () => import("@/components/modules/company-instruction/staff/StaffAirCompanyInstruction.vue")
const StaffPscCompanyInstruction = () => import("@/components/modules/company-instruction/staff/StaffPscCompanyInstruction.vue")

const StaffGeneralCompanyInstruction = () => import("@/components/modules/company-instruction/staff/StaffGeneralCompanyInstruction.vue")
const Login = () => import('../views/Login.vue');
const Base = () => import('../views/Base');

const Dashboard = () => import('../views/Dashboard');
const NumberOfManagement = () => import('../components/dashboard/NumberOfManagement');
const AiDashboard = () => import('../components/dashboard/AiDashboard');
const PscDashboard = () => import('../components/dashboard/PscDashboard');
const RightShipDashboard = () => import('../components/dashboard/RsDashboard.vue');
const RightshipSummaryOfFindings = () => import('../components/dashboard/rightship/SummaryOfFindings/RsSummaryOfFindings.vue');
const RightshipCommonFindings = () => import('../components/dashboard/rightship/CommonFindings/RsCommonFindings.vue');
const RsInspectorDashboard = () => import('../components/dashboard/rightship/inspectors/RsInspectorDashboard.vue');
const RsFindingsByPortDashboard = () => import('../components/dashboard/rightship/FindingsByPort/RsFindingsByPortDashboard.vue');
const PscDeficiencySummary = () => import('../components/dashboard/psc/PscDeficiencySummary');
const PscInspectionByCountry = () => import('../components/dashboard/psc/PscInspectionByCountry');
const PscMonthlyCommittee = () => import('../components/dashboard/psc/PscMonthlyCommittee');
const PscMonthlySummary = () => import('../components/dashboard/psc/PscMonthlySummary');
const PscYearlyOverview = () => import('../components/dashboard/psc/PscYearlyOverview');

const InvestigationDashboard = () => import('../components/dashboard/InvestigationDashboard.vue');

const PscDashboardGeneral = () => import('../components/dashboard/psc/PscDashboardGeneral');
const Masterlist = () => import('../views/Masterlist');
const Module = () => import('../views/Module');
const ReportIndex = () => import('../components/modules/ReportIndex');
const AccidentIncidentReport = () => import('../components/modules/accident-incident/AccidentIncidentReport');
const General = () => import('../components/modules/accident-incident/General');
const Event = () => import('../components/modules/accident-incident/Event');
const Loss = () => import('../components/modules/accident-incident/Loss');
const Cause = () => import('../components/modules/accident-incident/Cause');
const CorrectiveAction = () => import('../components/modules/accident-incident/CorrectiveAction');
const PreventiveAction = () => import('../components/modules/accident-incident/PreventiveAction');
const Feedback = () => import('../components/modules/accident-incident/Feedback');
const ShipParticular = () => import('../components/modules/accident-incident/ShipParticular');
const Vessel = () => import('../views/Vessel');
const VesselIndex = () => import('../components/vessel/VesselIndex');
const VesselAdd = () => import('../components/vessel/VesselAdd');
const VesselOverview = () => import('../components/vessel/VesselOverview');
const VesselCrewLists = () => import('../components/vessel/crew-list/CrewList.vue');

const VesselOnboardCrewLists = () => import('../components/vessel/crew-list/VesselOnboardCrewLists');
const VesselEmbarkDisembarkHistory = () => import('../components/vessel/crew-list/VesselEmbarkDisembarkHistory');
const VesselAccidentIncident = () => import('../components/vessel/VesselAccidentIncident')

// Company

const Company = () => import('../views/Company');
const CompanyIndex = ()  => import('../components/company/CompanyIndex');

const ShipsPI = () => import('../views/ShipsPI');

const ShipsPiAccidentIncident = () => import("@/components/ships-pi/ShipsPiAccidentIncident.vue");
const ShipsPiWorkingEnvironment = () => import("@/components/ships-pi/ShipsPiWorkingEnvironment.vue");
const ShipsPiPsc = () => import("@/components/ships-pi/ShipsPiPsc.vue");
const ShipsPiPSC = () => import("@/components/ships-pi/psc/ShipsPiPSC.vue");
const ShipsPiPSCNumberDeficiency = () => import("@/components/ships-pi/psc/ShipsPiPSCNumberDeficiency.vue");
const ShipsPiPSCNumberInspection = () => import("@/components/ships-pi/psc/ShipsPiPSCNumberInspection.vue");
const ShipsPiPSCDetention = () => import("@/components/ships-pi/psc/ShipsPiPSCDetention.vue");
const ShipsPiRightship = () => import("@/components/ships-pi/ShipsPiRightship.vue");
const WorkingEnvironments = () => import("@/components/ships-pi/WorkingEnvironments/WorkingEnvironments.vue");
const VesselParticular = () => import('../components/vessel/VesselParticular');
const Attachment = () => import('../components/modules/accident-incident/Attachment')
const AirCompanyInstruction = () => import('../components/modules/accident-incident/AirCompanyInstruction.vue')
const CrewInfo = () => import('../components/crew/profile/CrewInfo');
const Crew = () => import('../views/Crew')
const CrewProfile = () => import('../components/crew/profile/CrewProfile');
const CrewPersonal = () => import('../components/crew/profile/CrewPersonal')
const CrewEducation = () => import('../components/crew/profile/CrewEducation')
const CrewFamily = () => import('../components/crew/profile/CrewFamily')
const CrewAddress = () => import('../components/crew/profile/CrewAddress')
const CrewActivity = () => import('../components/crew/CrewActivity')
const Experience = () => import('../components/crew/experience/Experience')
const SeaExperience = () => import('../components/crew/experience/SeaExperience')
const OutsideExperience = () => import('../components/crew/experience/OutsideExperience')
const CrewBehavior = () => import('../components/crew/CrewBehavior');
const CrewDocument = () => import('../components/crew/document/Document');
const International = () => import('../components/crew/document/International')
const Certificates = () => import('../components/crew/document/Certificates')
const OtherTraining = () => import('../components/crew/document/OtherTraining')
const Licences = () => import('../components/crew/document/Licences')
const FlagDocument = () => import('../components/crew/document/FlagDocument')
const AssessmentReport = () => import('../components/crew/document/AssessmentReport')
const Main = () => import('../components/crew/document/medical/Main')
const MedicalDocuments = () => import('../components/crew/document/medical/Medical')
const HealthChecklist = () => import('../components/crew/document/medical/Checklist')
const Pcr = () => import('../components/crew/document/medical/Pcr')
const Vaccine = () => import('../components/crew/document/medical/Vaccine')
const Cer = () => import('../components/crew/CrewCer')
const Issue = () => import('../components/crew/issues/Issue')
const Medicals = () => import('../components/crew/issues/Medicals')
const Pandi = () => import('../components/crew/issues/Pandi')
const StaffCompanyInstruction = () => import('../components/modules/company-instruction/staff/StaffCompanyInstruction')
const MasterCompanyInstruction = () => import('../components/modules/company-instruction/master/MasterCompanyInstruction')
const StaffCompanyInstructionResponse = ()=> import("@/components/modules/company-instruction/master/StaffCompanyInstructionResponse.vue");
const VesselCompanyInstructionResponse = ()=> import("@/components/modules/company-instruction/master/VesselCompanyInstructionResponse.vue");
const VesselSisterShip = ()=> import("@/components/vessel/VesselSisterShip.vue");
const PscInspectionByMou = () => import("@/components/dashboard/psc/PscInspectionByMou.vue");
const PscInspectionByFlag = () => import("@/components/dashboard/psc/PscInspectionByFlag.vue");

const ContactList = () => import("@/components/contact-list/ContactList.vue");
const ContactListIndex = () => import("@/components/contact-list/ContactListIndex.vue");
import SmsRecord from "@/components/vessel/documents/partials/SmsRecord.vue";
import RsDashboard from "@/components/dashboard/RsDashboard.vue";
import {AuthenticationService} from "@/services/AuthenticationService";

Vue.use(VueRouter)

const login = {
  path: '/',
  name: 'Login',
  component: Login
}
const maintenance = {
  path: '/maintenance',
  name: 'MaintenanceMode',
  component: () => import('../components/MaintenanceMode'),
  meta: {
    requiresAuth: false
  },
  params: {
    maintenance: true
  }

}
const routes = [
  login,
  maintenance,
  {
    path: '/',
    name: 'Base',
    component: Base,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard/',
        name: 'Dashboard',
        component: Dashboard,
        redirect: 'dashboard/ai/number_of_report',
        children: [
          {
            path: 'vessel_info/:report_type',
            name: 'NumberOfManagement',
            component: NumberOfManagement
          },
          {
            path: 'ai/:chart_module',
            name: 'AiDashboard',
            component: AiDashboard
          },
          {
            path: 'psc/',
            name: 'PscDashboard',
            component: PscDashboard,
            redirect: 'psc/yearly',
            children: [
              {
                path: 'yearly',
                name: 'PscYearlyOverview',
                component: PscYearlyOverview,
              },
              {
                path: 'country',
                name: 'PscInspectionByCountry',
                component: PscInspectionByCountry,
              },
              {
                path: 'mou',
                name: 'PscInspectionByMOU',
                component: PscInspectionByMou,
              },
              {
                path: 'flag',
                name: 'PscInspectionByFlag',
                component: PscInspectionByFlag,
              },
              {
                path: 'monthly',
                name: 'PscMonthlySummary',
                component: PscMonthlySummary,
              },
              {
                path: 'monthly-committee',
                name: 'PscMonthlyCommittee',
                component: PscMonthlyCommittee,
              },
              {
                path: 'deficiency',
                name: 'PscDeficiencySummary',
                component: PscDeficiencySummary,
              },
              {
                path: 'general',
                name: 'PscDashboardGeneral',
                component: PscDashboardGeneral,
              },
            ]
          },
          {
            path: 'rs/',
            name: 'RsDashboard',
            component: RightShipDashboard,
            redirect: 'rs/number_of_findings',
            children: [
              {
                path: 'number_of_findings',
                name: 'RsNumberOfFindings',
                component: RightShipDashboard,
              },
              {
                path: 'summary_of_findings',
                name: 'RsSummaryOfFindings',
                component: RightshipSummaryOfFindings,
              },
              {
                path: 'inspector_dashboard',
                name: 'RsInspectorDashboard',
                component: RsInspectorDashboard,
              },
              {
                path: 'findings_by_port',
                name: 'RsFindingsByPortDashboard',
                component: RsFindingsByPortDashboard,
              },
              {
                path: 'common_findings',
                name: 'RsCommonFindings',
                component: RightshipCommonFindings,
              },
            ]
          },
          {
            path: 'inv/:chart_module',
            name: 'InvestigationDashboard',
            component: InvestigationDashboard,
          },
        ]
        // component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard')
      },
      {
        path: 'masterlist/',
        name: 'Masterlist',
        component: Masterlist
        // component: () => import(/* webpackChunkName: "masterlist" */ '../views/Masterlist')
      },
      {
        path: 'module/',
        name: 'Module',
        redirect: '/module/index',
        component: Module,
        // component: () => import(/* webpackChunkName: "module" */ '../views/Module'),
        children: [
          {
            path: 'index/',
            name: 'ReportIndex',
            component: ReportIndex
            // component: () => import(/* webpackChunkName: "index-module" */ '../components/modules/ReportIndex')
          },
          {
            path: ':id/',
            name: 'AccidentIncidentReport',
            component: AccidentIncidentReport,
            // component: () => import(/* webpackChunkName: "accident-incident" */ '../components/modules/accident-incident/AccidentIncidentReport'),
            redirect: ':id/general',
            children: [
              {
                path: 'general/',
                name: 'General',
                component: General
                // component: () => import(/* webpackChunkName: "ai-general" */ '../components/modules/accident-incident/General')
              },
              {
                path: 'event/',
                name: 'Event',
                component: Event
                // component: () => import(/* webpackChunkName: "ai-event" */ '../components/modules/accident-incident/Event')
              },
              {
                path: 'loss/',
                name: 'Loss',
                component: Loss
                // component: () => import(/* webpackChunkName: "ai-loss" */ '../components/modules/accident-incident/Loss')
              },
              {
                path: 'cause/',
                name: 'Cause',
                component: Cause
                // component: () => import(/* webpackChunkName: "ai-cause" */ '../components/modules/accident-incident/Cause')
              },
              {
                path: 'attachment/',
                name: 'Attachment',
                component: Attachment
                // component: () => import(/* webpackChunkName: "ai-cause" */ '../components/modules/accident-incident/Cause')
              },
              {
                path: 'corrective-action/',
                name: 'CorrectiveAction',
                component: CorrectiveAction
                // component: () => import(/* webpackChunkName: "ai-corrective-action" */ '../components/modules/accident-incident/CorrectiveAction')
              },
              {
                path: 'preventive-action/',
                name: 'PreventiveAction',
                component: PreventiveAction
                // component: () => import(/* webpackChunkName: "ai-preventive-action" */ '../components/modules/accident-incident/PreventiveAction')
              },
              {
                path: 'feedback/',
                name: 'Feedback',
                component: Feedback
                // component: () => import(/* webpackChunkName: "ai-feedback" */ '../components/modules/accident-incident/Feedback')
              },
              {
                path: 'ship-particular/:vesselId',
                name: 'ShipParticular',
                component: ShipParticular,
              },
              {
                path: 'company-instruction/',
                name: 'AirCompanyInstruction',
                component: AirCompanyInstruction
                // component: () => import(/* webpackChunkName: "ai-feedback" */ '../components/modules/accident-incident/Feedback')
              }
            ]
          }
        ]
      },
      RoutePsc,
      RouteRightship,
      RouteInternalAudit,
      {
        path: 'vessels/',
        name: 'Vessel',
        redirect: '/vessels/index',
        component: Vessel,
        // component: () => import(/* webpackChunkName: "vessel" */ '../views/Vessel'),
        children: [
          {
            path: 'index/',
            name: 'VesselIndex',
            component: VesselIndex
            // component: () => import(/* webpackChunkName: "index-module" */ '../components/vessel/VesselIndex')
          },
          {
            path: 'create/',
            name: 'VesselAdd',
            component: VesselAdd
            // component: () => import(/* webpackChunkName: "index-module" */ '../components/vessel/VesselAdd')
          },
          {
            path: ':id',
            name: 'VesselOverview',
            component: VesselOverview,
            // component: () => import(/* webpackChunkName: "accident-incident" */ '../components/vessel/VesselOverview'),
            children: [
              {path: 'particular', name: 'VesselParticular', component: VesselParticular},
              {path: 'sister-ship', name: 'VesselSisterShip', component: VesselSisterShip},
              {
                path: 'crews',
                name: 'VesselCrewLists',
                redirect: 'crews/onboard-crews',
                component : VesselCrewLists,
                children: [
                  {
                    path : 'onboard-crews',
                    name : 'VesselOnboardCrewLists',
                    component : VesselOnboardCrewLists
                  },
                  {
                    path : 'embark-disembark-history',
                    name : 'VesselEmbarkDisembarkHistory',
                    component : VesselEmbarkDisembarkHistory
                  }
                ]
              },
              {
                path: 'documents',
                name: 'VesselDocuments',
                component: VesselDocuments,
                redirect: 'documents/vessel-files',
                children: [
                  {
                    path: 'vessel-visitation',
                    name: 'VesselVisitation',
                    component: VesselVisitation
                  },
                  {
                    path: 'vessel-files',
                    name: 'VesselFiles',
                    component: VesselFiles
                  },
                  {
                    path: 'sms-record',
                    name: 'SmsRecord',
                    component: SmsRecord
                  },
                ]
              },
              {
                path: 'history',
                name: 'VesselHistory',
                component: VesselHistory,
                redirect: 'history/accident-incident',
                children: [
                  {
                    path: 'accident-incident',
                    name: 'VesselAccidentIncidentHistory',
                    component: AccidentIncidentHistory
                  },
                  {
                    path: 'psc-inspection',
                    name: 'VesselPscInspectionHistory',
                    component: PscInspectionHistory
                  },
                  {
                    path: 'vessel-internal-audit',
                    name: 'VesselInternalAuditHistory',
                    component: VesselInternalAuditHistory
                  },
                ],
              },
            ]
          }
        ]
      },
      {
        path:"contact-list",
        name:"ContactList",
        redirect: '/contact-list/index',
        component:ContactList,
        children: [
          {
            path:"index/",
            name:"ContactListIndex",
            component:ContactListIndex
          }
        ]
      },
      {
        path : 'companies/',
        name: 'Company',
        redirect: '/companies/index',
        component : Company,
        children: [
          {
            path: 'index/',
            name: 'CompanyIndex',
            component: CompanyIndex
            // component: () => import(/* webpackChunkName: "index-module" */ '../components/vessel/VesselIndex')
          },
        ]
      },
      {
        path: 'company-instruction/',
        name: 'CompanyInstruction',
        component: CompanyInstruction,
        redirect: 'company-instruction/staff/air',
        children: [
          {
            path:'staff/air',
            name:'StaffCiAir',
            component:StaffCompanyInstruction,
            meta: { key: 'staffAir' }
          },
          {
            path:'staff/psc',
            name:'StaffCiPsc',
            component:StaffCompanyInstruction,
            meta: { key: 'staffPsc' }
          },
          {
            path:'staff/rs',
            name:'StaffCiRs',
            component:StaffCompanyInstruction,
            meta: { key: 'staffRs' }
          },
          {
            path:'staff/vessel-audit',
            name:'StaffCiOe',
            component:StaffCompanyInstruction,
            meta: { key: 'staffOe' }
          },
          {
            path:'staff/vessel/response',
            name:'StaffVesselResponse',
            component:StaffCompanyInstructionResponse
          },
          {
            path:'master/air',
            name:'MasterCiAir',
            component:MasterCompanyInstruction
          },
          {
            path:'master/vessel/response',
            name:'MasterVesselResponse',
            component:VesselCompanyInstructionResponse
          },
          {
            path:'master/psc',
            name:'MasterCiPsc',
            component:MasterCompanyInstruction
          },
          {
            path:'master/rs',
            name:'MasterCiRs',
            component:MasterCompanyInstruction
          },
          {
            path:'staff/vessel/response/general',
            name:'MasterVesselResponse',
            component: StaffGeneralCompanyInstruction
          },
          {
            path:'master/vessel-audit',
            name:'MasterCiOe',
            component:MasterCompanyInstruction
          },
        ]
      },
      {
        path: 'ships-pi/',
        name: 'ShipsPI',
        component: ShipsPI,
        children: [
          {
            path : 'accident-incident',
            name : 'ShipsPiAccidentIncident',
            component: ShipsPiAccidentIncident,
            redirect: 'accident-incident/number_of_report',
            children: [
              {
                path : ':feature',
                name : 'VesselAccidentIncident',
                component : VesselAccidentIncident
              },
            ]
          },
          {
            path : 'psc',
            name : 'ShipsPiPSC',
            component: ShipsPiPSC,
            redirect: 'psc/number_of_deficiency',
            children: [
              {
                path: 'number_of_deficiency',
                name: 'ShipsPiPSCNumberDeficiency',
                component: ShipsPiPSCNumberDeficiency,
              },
              {
                path: 'number_of_inspection',
                name: 'ShipsPiPSCNumberInspection',
                component: ShipsPiPSCNumberInspection,
              },
              {
                path: 'detention',
                name: 'ShipsPiPSCDetention',
                component: ShipsPiPSCDetention,
              },
            ]
          },
          {
            path : 'working-environment',
            name : 'ShipsPiWorkingEnvironment',
            component: ShipsPiWorkingEnvironment,
            redirect: 'working-environment/medical_type',
            children: [
              {
                path : ':feature',
                name : 'WorkingEnvironments',
                component : WorkingEnvironments
              },
            ]
          },
          {
            path : 'rightship-inspection',
            name : 'ShipsPiRightship',
            component: ShipsPiRightship,
          }
        ]
      },
      RouteSettings,
      {
        name: 'Crew',
        path: 'crew/',
        component: Crew,
        children: [
          {
            name: 'CrewInfo',
            path: ':id/',
            component: CrewInfo,
            redirect: ':id/activities',
            children: [
              {
                name: 'CrewProfile',
                path: 'profile/',
                component: CrewProfile,
                redirect: 'profile/personal',
                children: [
                  {
                    name: 'CrewPersonal',
                    path: 'personal/',
                    component: CrewPersonal,
                  },
                  {
                    name: 'CrewEducation',
                    path: 'education/',
                    component: CrewEducation,
                  },
                  {
                    name: 'CrewFamily',
                    path: 'family/',
                    component: CrewFamily,
                  },
                  {
                    name: 'CrewAddress',
                    path: 'address/',
                    component: CrewAddress,
                  },

                ]
              },
              {
                name: 'CrewActivity',
                path: 'activities/',
                component: CrewActivity,
              },
              {
                name: 'Experience',
                path: 'experience/',
                component: Experience,
                redirect: "experience/sea_experience",
                children: [
                  {
                    name: 'SeaExperience',
                    path: 'sea_experience',
                    component: SeaExperience
                  },
                  {
                    name: 'OutsideExperience',
                    path: 'outside_experience',
                    component: OutsideExperience
                  }
                ],
              },
              {
                name: 'CrewBehavior',
                path: 'behavior/',
                component: CrewBehavior,
              },
              {
                name: 'CrewDocument',
                path: 'document/',
                component: CrewDocument,
                redirect: 'document/international',
                children: [
                  {
                    name: 'CrewInternational',
                    path: 'international/',
                    component: International,
                  },
                  {
                    name: 'CrewCertificates',
                    path: 'certificates/',
                    component: Certificates,
                  },
                  {
                    name: 'CrewTraining',
                    path: 'other-training/',
                    component: OtherTraining,
                  },
                  {
                    name: 'CrewLicences',
                    path: 'licences/',
                    component: Licences,
                  },
                  {
                    name: 'CrewFlagDocument',
                    path: 'flag-documents/',
                    component: FlagDocument,
                  },
                  {
                    name: 'CrewAssessmentReport',
                    path: 'assessment-report/',
                    component: AssessmentReport,
                  },
                  {
                    name: 'CrewMedical',
                    path: 'medicals/',
                    component: Main,
                    redirect: 'medicals/documents',
                    children: [
                      {
                        name: 'CrewMedicalDocument',
                        path: 'documents/',
                        component: MedicalDocuments
                      },
                      {
                        name: 'CrewHealthChecklist',
                        path: 'health-checklist/',
                        component: HealthChecklist
                      },
                      {
                        name: 'CrewPcr',
                        path: 'rt-pcr',
                        component: Pcr,
                      },
                      {
                        name: 'CrewVaccine',
                        path: 'vaccine',
                        component: Vaccine,
                      },
                    ]
                  },
                ]
              },
              {
                name: 'CrewCer',
                path: 'cer',
                component: Cer
              },
              {
                name: 'Issues',
                path: 'issues',
                component: Issue,
                redirect: 'issues/medical',
                children: [
                  {
                    name: 'Medicals',
                    path: 'medical/',
                    component: Medicals,
                  },
                  {
                    name: 'Pandi',
                    path: 'pandi/',
                    component: Pandi,
                  },
                ]
              }
            ]
          }
        ]
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const ssoToken = typeof to.query.sso_token === 'string' ? to.query.sso_token : null;
  const userLegacyId = typeof to.query.user_id === 'string' ? to.query.user_id : null;
  const redirectPathName = typeof to.query.redirect_path_name === 'string' ? to.query.redirect_path_name : null;
  // Carries a route PARAM through to the destination alongside
  // redirect_path_name, for a per-record detail route (e.g. the
  // accident-incident Loss page, name 'Loss', nested under a parent
  // requiring :id) - additive and optional, so every existing flat/
  // param-less redirect_path_name caller (ReportIndex, PscIndex, ...) is
  // unaffected (see FIX_REQUEST...SsoGuardCantCarryRouteParam.md).
  const redirectPathId = typeof to.query.redirect_path_id === 'string' ? to.query.redirect_path_id : null;
  // From KIDS v2's sidebar (its KIDS v1 menu, 2026-10-30), both additive and
  // optional like redirect_path_id: the `type` a page reads from its query
  // (the Company Instruction pages: air, psc, rs, ia_oe), and "the user's own
  // vessel" for a page whose :vessel_id is the vessel account's own (Audit
  // Records) - v1 knows that vessel, v2 doesn't.
  const redirectPathType = typeof to.query.redirect_path_type === 'string' ? to.query.redirect_path_type : null;
  const redirectPathOwnVessel = to.query.redirect_path_own_vessel === '1';
  const isAuthenticated = localStorage.getItem(TOKEN_NAME) !== null;

  // Helper to resolve the target route based on vessel or redirect query.
  // query: {} is explicit (not just "omitted") on every branch below except
  // MasterCiAir (which already sets its own real query) - an explicit empty
  // query is what guarantees sso_token/user_id/redirect_path_name/
  // redirect_path_id never survive into the resolved URL/history entry (see
  // FIX_REQUEST...SsoTokenLeftInUrl.md - leaving query unset risked it being
  // treated as "keep whatever's already there" rather than "none").
  const getDestinationRoute = (userVesselId) => {
    // An own-vessel page for a user without a vessel falls back to the
    // default below, instead of a route missing its :vessel_id.
    if (redirectPathName && !(redirectPathOwnVessel && !userVesselId)) {
      const params = {};
      if (redirectPathId) params.id = redirectPathId;
      if (redirectPathOwnVessel) params.vessel_id = userVesselId;
      // t: a fresh value each time, as v1's own sidebar links to these pages
      // add (the Company Instruction pages are keyed on their query).
      const query = redirectPathType ? { type: redirectPathType, t: Date.now() } : {};
      return { name: redirectPathName, params, query };
    }
    return userVesselId
      ? { name: 'MasterCiAir', query: { type: 'air', t: Date.now() } }
      : { name: 'Dashboard', query: {} };
  };

  // 1. Handle SSO Login
  if (ssoToken && userLegacyId) {
    if (isAuthenticated) {
      const userInfo = JSON.parse(localStorage.getItem(USER_DETAILS) || '{}');
      const targetRoute = getDestinationRoute(userInfo?.vessel_id);

      // Always resolve via targetRoute (never a bare next(), which would
      // continue with `to` AS-IS - including its full sso_token/user_id/
      // redirect_path_name/redirect_path_id query string) - even when
      // to.name already happens to match the destination name, the QUERY
      // still needs stripping (see FIX_REQUEST...SsoTokenLeftInUrl.md).
      return next(targetRoute);
    }

    try {
      const result = await AuthenticationService.ssoLogin({
        sso_token: ssoToken,
        user_id: userLegacyId,
      });

      const targetRoute = getDestinationRoute(result?.user?.vessel_id);
      return next(targetRoute);
    } catch (error) {
      console.error('SSO login failed:', error);
      return next('/');
    }
  }

  // 2. Protected Routes
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (isAuthenticated) {
      return next();
    }
    // Master's original behavior: remember the intended destination so the
    // guest-route branch below can send the user back here after login.
    return next({
      path: '/',
      query: { redirect: to.fullPath }
    });
  }

  // 3. Guest-Only Routes (Redirect logged-in users away)
  if (isAuthenticated && localStorage.getItem(USER_DETAILS)) {
    try {
      const userInfo = JSON.parse(localStorage.getItem(USER_DETAILS));

      // Master's redirect=<fullPath> (set by the block above) takes
      // priority over the vessel_id/redirect_path_name default - this is
      // the pre-existing "return to where you were going" flow, distinct
      // from redirect_path_name which only the new SSO flow sets.
      const redirectUrl = to.query.redirect;
      if (redirectUrl) {
        return next(redirectUrl);
      }

      const targetRoute = getDestinationRoute(userInfo?.vessel_id);
      if (to.name !== targetRoute.name) {
        return next(targetRoute);
      }
    } catch (e) {
      console.error('Failed to parse USER_DETAILS:', e);
    }
  }

  return next();
});

// Defense-in-depth alongside the query:{} fix inside the guard above: no
// matter which code path a navigation took, if the RESOLVED route still
// carries any SSO param in its query (sso_token is a one-time, 60s-TTL
// credential - it must never linger in the visible URL, browser history,
// or get sent onward via a referrer header), replace the history entry
// with the clean equivalent immediately. afterEach (not beforeEach) is the
// safe place for this - the navigation has already resolved, so
// router.replace() here is a normal follow-up navigation, not a guard
// re-entrancy risk (see FIX_REQUEST...SsoTokenLeftInUrl.md).
const SSO_QUERY_KEYS = ['sso_token', 'user_id', 'redirect_path_name', 'redirect_path_id'];

router.afterEach((to) => {
  if (!SSO_QUERY_KEYS.some((key) => key in to.query)) return;

  const cleanQuery = { ...to.query };
  SSO_QUERY_KEYS.forEach((key) => { delete cleanQuery[key]; });

  router.replace({ path: to.path, query: cleanQuery, hash: to.hash }).catch(() => {
    // A NavigationDuplicated-style rejection here just means something else
    // already navigated away in the meantime - nothing to clean up.
  });
});

export default router
